<script setup lang="ts">

import type NewsItem from "@/types/NewsItem.ts";
import { useGameStore } from '@/stores/gameStore.ts'
import NewsItemBaseStructure from '@/components/Sections/News/Types/Base/NewsItemBaseStructure.vue'
import NewsItemBase from '@/components/Sections/News/Types/Base/NewsItemBase.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const gameStore = useGameStore()

const props = defineProps<{
  newsItem: NewsItem,
  toast: boolean
}>();

</script>

<template>
  <NewsItemBase
    :toast="toast"
    :toast-image="gameStore.cdn + 'images/planet/new/128/planet_7.png'"
    :toast-text="t('news.types.ferionPlanetFound.title')"
  >
      <NewsItemBaseStructure
        :newsItem="props.newsItem"
        :item-image="gameStore.cdn + 'images/planet/new/128/planet_7.png'"
        :header="t('news.types.ferionPlanetFound.title')"
      >
        <p class="pb-2">{{ t('news.types.ferionPlanetFound.body') }}</p>
      </NewsItemBaseStructure>
  </NewsItemBase>
</template>

<style scoped lang="scss">

</style>